import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const WhoWeAreSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="py-20 sm:py-28 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-gold-accent/5 rounded-full blur-3xl" />
      
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-primary mb-8">
            Who We Are
          </h2>

          <div className="space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
            <p>
              True Passage Ventures is a global sourcing and procurement partner helping businesses identify, vet, and work with reliable manufacturing and supply partners across India and key international supply markets.
            </p>

            <p>
              Through a combination of regional supplier intelligence, structured evaluation, and technology-driven processes, we simplify global procurement and help companies build dependable supplier relationships.
            </p>

            <p className="font-semibold text-navy-primary">
              Our focus is simple: make global sourcing transparent, efficient, and reliable for businesses that need consistent results.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
